import { Component } from "react";
import Modal from "../common_modal/Modal";
import dict from "../../Data/dict.json";
import { get_country_code_and_phone_number } from "../../App/validation/phone_number";

import { get_country_calling_codes } from "../../App/validation/countries";
import { MenuItem, Select } from "@mui/material";

const phoneNumberList = get_country_calling_codes();

export default class PhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: 62,
      phoneNumber: "",
      modalNotification: false,
    };
  }

  toggleModalNotification = () => {
    this.setState({ modalNotification: !this.state.modalNotification });
  };

  componentDidMount = () => {
    this.update_value();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps?.params?.value !== this.props?.params?.value) {
      this.update_value();
    }
  };

  update_value = () => {
    const { countryCode, phoneNumber } = get_country_code_and_phone_number(
      this.props.params.value
    );

    this.setState({
      countryCode: countryCode || 62,
      phoneNumber,
    });
  }

  mergeCountryAndPhoneNumber = () => {
    return Number(`${this.state.countryCode}${this.state.phoneNumber}`);
  };

  handleSubmit = () => {
    const phoneNumber = parseInt(this.state.phoneNumber);
    if (!Number.isInteger(phoneNumber)) {
      this.toggleModalNotification();
    } else if (this.state.phoneNumber === "" || Number.isInteger(phoneNumber)) {
      const result = this.mergeCountryAndPhoneNumber();
      const newParams = {
        ...this.props.params,
        value: result,
      };
      this.props.handleEditCellChange(
        this.props.editProperties,
        this.props.layer_id,
        newParams
      );
    }
  };

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";

    const { countryCode, phoneNumber } = this.state;

    const modalNotification = this.state.modalNotification && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={this.state.modalNotification}
        onClose={(params) => this.toggleModalNotification(params)}
      >
        <main style={{ margin: 20 }}>
          {dict["Invalid time input, please try again!"][language]}
          <button
            className="button background_black"
            id="deleteBright"
            style={{
              marginTop: "1rem",
              display: "block",
              width: "100%",
              justifyContent: "center",
            }}
            onClick={this.toggleModalNotification}
          >
            OK
          </button>
        </main>
      </Modal>
    );
    return (
      <section>
        <div className="parent_phone_number">
          <Select
            value={countryCode}
            label="Currency"
            onChange={(e) => {
              this.setState({ countryCode: e.target.value }, () => {
                this.handleSubmit();
              });
            }}
            sx={{
              boxShadow: "none",
              "&.Mui-focused fieldset": { border: "none" },
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
            }}
            renderValue={() => {
              // here you can add you logic for your selected value
              return `+${countryCode}`;
            }}
          >
            {phoneNumberList.map(({ country_name, calling_code }, index) => (
              <MenuItem key={index} value={calling_code}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{calling_code}</span>
                  <span style={{ color: "#888" }}>{country_name}</span>
                </div>
              </MenuItem>
            ))}
          </Select>

          <input
            type="number"
            className="phone_in_table"
            style={{ marginLeft: 5, width: 150 }}
            value={phoneNumber}
            onChange={(params) => {
              if (
                params.nativeEvent.inputType === "deleteContentBackward" ||
                phoneNumber.length < 15
              ) {
                this.setState({ phoneNumber: params.target.value });
              }
            }}
            onKeyDown={(params) => {
              if (params.key === "Enter") {
                this.handleSubmit();
                params.target.blur();
              }
            }}
            onBlur={(params) => {
              this.handleSubmit();
            }}
          />
        </div>
        {/* <div>{`+${this.state.countryCode} ${this.state.phoneNumber}`}</div> */}
        {modalNotification}
      </section>
    );
  }
}
